/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Content_Manual_DescInputs */

const en_directory_submit_content_manual_desc = /** @type {(inputs: Directory_Submit_Content_Manual_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the form and write the details yourself.`)
};

const zh_directory_submit_content_manual_desc = /** @type {(inputs: Directory_Submit_Content_Manual_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开表单，自己填写详情。`)
};

/**
* | output |
* | --- |
* | "Open the form and write the details yourself." |
*
* @param {Directory_Submit_Content_Manual_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_content_manual_desc = /** @type {((inputs?: Directory_Submit_Content_Manual_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Content_Manual_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_content_manual_desc(inputs)
	return zh_directory_submit_content_manual_desc(inputs)
});
export { directory_submit_content_manual_desc as "directory.submit.content.manual_desc" }